import URLConst from '../constants/URLConst';
import { fetchJSON, secureDELETE, secureGET, securePOST, securePUT } from '../utilities/FetchHelper';

class RatePlanConfigurationService {

    getConfigurableRatePlans() {
        let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_CONFIGURE_RATE_PLANS_GET

        return fetchJSON(url, secureGET()).then(response => {
            return response
        }).catch((error) => {
            throw error
        })
    }

    addConfigurableRatePlan(data) {
        let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_CONFIGURE_RATE_PLANS_POST

        return fetchJSON(url, { ...securePOST(), body: JSON.stringify(data) }).then(response => {
            return response
        }).catch((error) => {
            throw error
        })
    }

    updateConfigurableRatePlan(data) {
        let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_CONFIGURE_RATE_PLANS_PUT_DELETE
        url = url.replace('{code}', data.code)
        
        return fetchJSON(url, { ...securePUT(), body: JSON.stringify(data) }).then(response => {
            return response
        }).catch((error) => {
            throw error
        })
    }

    deleteConfigurableRatePlan(code) {
        let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_CONFIGURE_RATE_PLANS_PUT_DELETE
        url = url.replace('{code}', code)
        
        return fetchJSON(url, secureDELETE()).then(response => {
            return response
        }).catch((error) => {
            throw error
        })
    }
}

export default new RatePlanConfigurationService()